import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from "react-responsive-carousel";


const QuotesSection = ({}) => {

    return (
        <div className="hide-when-right-to-left-language py-5">
            <div className="container bg-light-blue testimonials-container text-center p-5" style={{backgroundRepeat: "no-repeat", backgroundPosition: "right"}}>
                <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                    <div key="1" className="p-3 mb-3">
                        <div className="p-3">
                            <div className="center mw-800px font-etihad">
                                <h4 style={{fontSize: '1.6rem', lineHeight: 1.2}}>&apos;&apos;As a frequent travel booker for my company, I find Climate Friendly Traveller easy to use to offset our travellers carbon. We know it&apos;s important to reduce the carbon footprint of our company when we travel both domestically and internationally.&apos;&apos;</h4>
                            </div>
                        </div>
                    </div>

                    <div key="2" className="p-3 mb-3">
                        <div className="p-3">
                            <div className="center mw-800px font-etihad">
                                <h4 style={{fontSize: '1.6rem', lineHeight: 1.2}}>&apos;&apos;Flying is an important part of my life, I fly for work, when visiting family and for holidays. I use Etihad Climate Friendly Traveller to easily offset my flight emissions to help me travel responsibly.&apos;&apos;</h4>
                            </div>
                        </div>
                    </div>

                    <div key="3" className="p-3 mb-3">
                        <div className="p-3">
                            <div className="center mw-800px font-etihad">
                                <h4 style={{fontSize: '1.6rem', lineHeight: 1.2}}>&apos;&apos;Everyone needs to do their part to help fight climate change, A tool like Climate Friendly Traveller makes it quick and simple to remove our travel emissions without having to give up on flying.&apos;&apos;</h4>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        </div>
    )
}


export default QuotesSection;